import React from "react";
import FooterSocialLinks from "./FooterSocialLinks";
import FooterRecipe from "./FooterRecipe";

const FooterPage = () => {
  return (
    <footer className="page-footer font-small pt-0" style={{marginTop: "-7.6px", backgroundColor: "#686868"}}>

        <div className="container">
            <FooterRecipe/>
            <div className="col-6 col-lg-2 mx-auto mb-4">
              <img src="https://camillahardilla.com/wp-content/uploads/2020/07/my-recipes-logo.png" className="img-fluid" />
            </div>
            
            <FooterSocialLinks/>
        </div>
 
        <div className="footer-copyright text-center py-3">
          <div className="container-fluid">© 2020 Copyright:<a href="https://www.progitek.no" alt=""> Ole Petter Kyrkjebø Hjønnevåg </a></div>
        </div>
    </footer>
  );
}

export default FooterPage;